var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
/**
 * aタグのラッパーコンポーネント。主に外部リンク用、内部リンクの場合はRouterLinkを利用すること
 * @param props
 * @constructor
 */
export const ExternalLink = (props) => {
    const { children, className, dataAttributes = {}, rel: _rel, target } = props, otherProp = __rest(props, ["children", "className", "dataAttributes", "rel", "target"]);
    const rel = target === '_blank' && !_rel ? 'noopener noreferrer' : undefined;
    return (_jsx("a", Object.assign({}, otherProp, dataAttributes, { className: clsx(className), rel: rel, target: target }, { children: children })));
};
